module.exports = __webpack_public_path__ + "static_pc/img/18.6b07c281.png";